import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {GlobalService} from './global.service';
import { Resource } from '../models/resource';
import { ResourceType } from '../models/resource';
import { Content } from '../models/content';
import { Poster } from '../models/poster';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

@Injectable()
export class ResourceService {

  private BASE_URL: string;
  private header: Headers;
  private headerSubscription: Subscription;
  private tempResourcePreviews: JSON;
  private tempResourceThumbPreviews: JSON;
  private tempPosterPreviews: JSON;
  private tempPosterThumbPreviews: JSON;
  
  constructor(private http: HttpClient, private globals: GlobalService) {
    this.BASE_URL = globals.BASE_URL;
    /*this.headerSubscription = this.globals.getHeader()
    .subscribe(header => {
      this.header = header;
    });*/
    this.tempResourcePreviews = JSON.parse("{}");
    this.tempResourceThumbPreviews = JSON.parse("{}");
    this.tempPosterPreviews = JSON.parse("{}");
    this.tempPosterThumbPreviews = JSON.parse("{}");
  }

  getResourcesPaginationInfo(typeID: number, content: Content, searchStr?: string): any{
    let self = this;
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/getresourcecount/` + typeID;
      if(searchStr != null && searchStr.length > 0) url += '/'+searchStr;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            //self.globals.setHeader(res.headers.get('authorization'));
            var data = res.body;
            resolve(data);
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  getResourcesForPage(pgno: number, pgcount: number, typeID: number, content: Content, searchStr?: string): any{
    let self = this;
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/getmedia/` + typeID +`/` + pgno + `/` + pgcount;
      if(searchStr != null && searchStr.length > 0) url += '/'+searchStr;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            //self.globals.setHeader(res.headers.get('authorization'));
            var resources = [];
            var data = res.body;
            for (var i in data) {
              let bg = new Resource(data[i].mediaID, data[i].directorID, data[i].name, data[i].typeID, data[i].previewURL, data[i].thumbPreviewURL);
              if(data[i].resourceType){
                var rtype = new ResourceType(data[i].resourceType.mediaTypeID, data[i].resourceType.type);
                bg.setResourceType(rtype);
              }
              if(this.tempResourcePreviews[data[i].mediaID]){
                bg.mainPreview = this.tempResourcePreviews[data[i].mediaID];
              }
              if(this.tempResourceThumbPreviews[data[i].mediaID]){
                bg.thumbPreview = this.tempResourceThumbPreviews[data[i].mediaID];
              }
              resources.push(bg);
            }
            resolve(resources);
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  getResourcePreview(resource: Resource): Observable<any>{
    if(resource != null){
      var self = this;
      return this.http.get(resource.previewURL,{ observe: 'response', responseType: 'json' })
      .map(response => {
        self.tempResourcePreviews[resource.getID()] = response.body;
        return response.body;
      });  
    } else{
      return null;
    }
  }

  getResourceThumbPreview(resource: Resource): Observable<any>{
    if(resource != null){
      var self = this;
      return this.http.get(resource.thumbPreviewURL,{ observe: 'response', responseType: 'json' })
      .map(response => {
        self.tempResourceThumbPreviews[resource.getID()] = response.body;
        return response.body;
      });  
    } else{
      return null;
    }
  }


  getPostersPaginationInfo(content: Content, searchStr?: string): any{
    let self = this;
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/getpostercount`;
      if(searchStr != null && searchStr.length > 0) url += '/'+searchStr;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            //self.globals.setHeader(res.headers.get('authorization'));
            var data = res.body;
            resolve(data);
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  getPostersForPage(pgno: number, pgcount: number, content: Content, searchStr?: string): any{
    let self = this;
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/getposter/` + pgno + `/` + pgcount;
      if(searchStr != null && searchStr.length > 0) url += '/'+searchStr;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            //self.globals.setHeader(res.headers.get('authorization'));
            var posters = [];
            var data = res.body;
            posters = Poster.getPostersFromJSONArray(data);
            for(var i in posters){
              if(this.tempPosterPreviews[posters[i].posterID]){
                posters[i].mainPreview = this.tempPosterPreviews[posters[i].posterID];
              }
              if(this.tempPosterThumbPreviews[posters[i].posterID]){
                posters[i].thumbPreview = this.tempPosterThumbPreviews[posters[i].posterID];
              }
            }
            resolve(posters);
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  getPosterPreview(poster: Poster): Observable<any>{
    if(poster != null){
      var self = this;
      return this.http.get(poster.previewURL,{ observe: 'response', responseType: 'json' })
      .map(response => {
        self.tempPosterPreviews[poster.getPosterID()] = response.body;
        return response.body;
      });  
    } else{
      return null;
    }
  }

  getPosterThumbPreview(poster: Poster): Observable<any>{
    if(poster != null){
      var self = this;
      return this.http.get(poster.thumbPreviewURL,{ responseType:'text'})
      .map(response => {
        self.tempPosterThumbPreviews[poster.getPosterID()] = response;
        return response;
      });  
    } else{
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/resource.service.ts